import React, { useState, createContext, useEffect } from "react"
import { setLocalStorage, isBrowser, lockScroll } from "../util"
import enums from "../util/enums"

export const Context = createContext()

const persistedEmailId = "marco_email_capture"

const initialStoreState = {
  caseBuilderMode: enums.mode.view,
  isCartOpen: false,
  isEmailModalOpen: false,
  isFlavorNotesOpen: false,
  isHowItWorksOpen: false,
  isMobile: null,
  isSiteCreditOpen: false,
  isNoteModalOpen: false,
}

const ContextProvider = ({ children }) => {
  const [store, updateStore] = useState(initialStoreState)

  function handler() {
    if (
      window.innerWidth <= 768 &&
      (store.isMobile === false || store.isMobile === null)
    ) {
      updateStore(prevState => {
        return {
          ...prevState,
          isMobile: true,
        }
      })
    }
    if (
      window.innerWidth > 768 &&
      (store.isMobile === true || store.isMobile === null)
    ) {
      updateStore(prevState => {
        return {
          ...prevState,
          isMobile: false,
        }
      })
    }
  }

  useEffect(() => {
    if (isBrowser) {
      window.addEventListener("resize", handler)
    }
    return () => {
      if (isBrowser) window.removeEventListener("resize", handler)
    }
  })

  useEffect(() => {
    if (isBrowser && store.isMobile === null) {
      handler()
    }
  }, []) //eslint-disable-line

  return (
    <Context.Provider
      value={{
        store,
        setCaseBuilderMode: caseBuilderMode => {
          updateStore(prevState => {
            if (caseBuilderMode === enums.mode.bundle) {
              lockScroll(true)
            } else {
              lockScroll(false)
            }
            return {
              ...prevState,
              caseBuilderMode,
            }
          })
        },
        setEmailTimestamp: () => {
          const timeStamp = Date.now()
          setLocalStorage(persistedEmailId, timeStamp)
        },
        toggleEmailModal: () => {
          updateStore(prevState => {
            if (!prevState.isEmailModalOpen === true) {
              lockScroll(true)
            } else {
              lockScroll(false)
            }
            return {
              ...prevState,
              isEmailModalOpen: !prevState.isEmailModalOpen,
            }
          })
        },
        toggleFlavorNotesOpen: () => {
          updateStore(prevState => {
            if (!prevState.isFlavorNotesOpen === true) {
              lockScroll(true)
            } else {
              lockScroll(false)
            }
            return {
              ...prevState,
              isFlavorNotesOpen: !prevState.isFlavorNotesOpen,
            }
          })
        },
        toggleHowItWorksOpen: () => {
          updateStore(prevState => {
            if (!prevState.isHowItWorksOpen === true) {
              lockScroll(true)
            } else {
              lockScroll(false)
            }
            return {
              ...prevState,
              isHowItWorksOpen: !prevState.isHowItWorksOpen,
            }
          })
        },
        toggleSiteCredit: () => {
          updateStore(prevState => {
            return {
              ...prevState,
              isSiteCreditOpen: !prevState.isSiteCreditOpen,
            }
          })
        },
        toggleNoteModal: () => {
          updateStore(prevState => {
            return {
              ...prevState,
              isNoteModalOpen: !prevState.isNoteModalOpen,
            }
          })
        },
        setIsCartOpen: bool => {
          updateStore(prevState => {
            return {
              ...prevState,
              isCartOpen: bool,
            }
          })
          if (isBrowser) {
            if (bool) {
              document.getElementById("cart").focus()
            } else {
              document.body.focus()
            }
          }
        },
      }}
    >
      {children}
    </Context.Provider>
  )
}
export default ContextProvider
